{
  "accept": "نعم",
  "account_is_inactive": "حسابك غير نشط.",
  "analytics_chart_frequency_d": "كل يوم",
  "analytics_chart_frequency_h": "كل ساعه",
  "analytics_chart_frequency_m": "كل شهر",
  "analytics_chart_frequency_w": "كل اسبوع",
  "analytics_charts": "الرسوم البيانية",
  "analytics_clicks_title": "لا نقرات",
  "analytics_date": "التاريخ",
  "analytics_description_clicks_empty": "لا توجد بيانات للنقرات وجدت.",
  "analytics_description_empty": "لا توجد بيانات للفترة المحددة.",
  "analytics_event_bounce": "فشل التسليم",
  "analytics_event_clicks": "تم النقر",
  "analytics_event_delivered": "تم تسليمها",
  "analytics_event_drop": "تم اسقاطها",
  "analytics_event_open": "تم فتحها",
  "analytics_event_queued": "في قائمه الإنتظار",
  "analytics_event_sent": "تم تسليمها",
  "analytics_event_spam": "الرسائل الغير مرغوب فيها",
  "analytics_event_unsubscribes": "إلغاء الأشتراك",
  "analytics_events": "الحاله",
  "analytics_events_all": "الكل",
  "analytics_events_bounce": "فشل التسليم",
  "analytics_events_bounce_tooltip": "النسبة المئوية لعدد رسائل البريد الإلكتروني المرفوضة من قبل خوادم المستلمين وعددهم.",
  "analytics_events_bounces": "فشل التسليم",
  "analytics_events_clicks": "تم النقر",
  "analytics_events_clicks_tooltip": "النسبة المئوية وعدد الأشخاص الذين نقروا على رابط واحد على الأقل في رسالتك.",
  "analytics_events_delivered": "تم تسليمها",
  "analytics_events_delivered_tooltip": "النسبة المئوية للرسائل التي تم تسليمها إلى المستلمين وعددها.",
  "analytics_events_drop": "تم اسقاطها",
  "analytics_events_opens": "تم فتحها",
  "analytics_events_opens_tooltip": "النسبة المئوية لعدد رسائل البريد الإلكتروني التي فتحها المستلمون وعددها.",
  "analytics_events_queued": "في قائمه الإنتظار",
  "analytics_events_sent": "تم تسليمها",
  "analytics_events_spam": "الرسائل الغير مرغوب فيها",
  "analytics_events_unsubscribes": "إلغاء الأشتراك",
  "analytics_file": "اسم الملف",
  "analytics_filterby_domain": "نطاق",
  "analytics_filterby_recipient": "المرسل إليه",
  "analytics_filterby_sender": "الراسل",
  "analytics_filterby_subject": "الموضوع",
  "analytics_numbers": "أعداد",
  "analytics_openclick": "فتح / انقر فوق التحليلات",
  "analytics_overview": "ملخص",
  "analytics_percentage": "نسبة مئوية",
  "analytics_reason": "سبب",
  "analytics_recipient": "المرسل إليه",
  "analytics_sender": "الراسل",
  "analytics_status": "الحاله",
  "analytics_subject": "الموضوع",
  "analytics_temporary_error": "حدث خطأ مؤقت. الرجاء معاودة المحاولة في وقت لاحق.",
  "analytics_title": "الإحصائيات",
  "analytics_topforopens": "قمة للفتح",
  "analytics_total_emails": "عنوان بريد-إلكتروني مرفوع",
  "analytics_total_processed": "تم معالجه",
  "analytics_upload_date": "تاريخ الرفع",
  "and": "و",
  "annually": "سنوي",
  "authentication_expired": "قم بتغيير كلمة المرور الخاصة بك في هذه المنطقة. يتم استخدام هذه الكلمة فقط للوصول إلى لوحة التحكم.",
  "billing_changepassword_title": "غير كلمه السر",
  "billing_contact_were_not_found": "لا يوجد معلومات عن جهة التواصل بخصوص الفواتير",
  "billing_contacts_address": "العنوان",
  "billing_contacts_address2": "العنران ٢",
  "billing_contacts_billing": "رسائل خاصة بالفواتير او التذكير بفواتيرك",
  "billing_contacts_button_add": "أضف",
  "billing_contacts_button_edit": "عدل",
  "billing_contacts_city": "مدينه",
  "billing_contacts_company": "اسم الشركه",
  "billing_contacts_country": "البلد",
  "billing_contacts_editcontact": "تعديل جهة الاتصل",
  "billing_contacts_email": "عنوان البريد الالكتروني",
  "billing_contacts_empty": "سيتم إرسال رسائل البريد الإلكتروني إلى العنوان الموجود في حسابك الرئيسي. أدخل المزيد من العناوين لإرسال اتصالات إلى مستلمين إضافيين.",
  "billing_contacts_firstname": "الاسم الأول",
  "billing_contacts_lastname": "الكنية",
  "billing_contacts_marketing": "رسائل البريد الإلكتروني للخدمة - إشعارات التجديد وتأكيدات التسجيل وما إلى ذلك.",
  "billing_contacts_phone": "رقم التليفون",
  "billing_contacts_products": "رسائل البريد الإلكتروني للمنتج - تفاصيل الطلب ورسائل البريد الإلكتروني الترحيبية وما إلى ذلك.",
  "billing_contacts_slide_description": "سيتم إرسال رسائل البريد الإلكتروني إلى العنوان الموجود في حسابك الرئيسي. أدخل المزيد من العناوين لإرسال اتصالات إلى مستلمين إضافيين.",
  "billing_contacts_slide_title": "إضافة جهة اتصال جديدة",
  "billing_contacts_stateregion": "الولاية / المنطقة / المقاطعة",
  "billing_contacts_support": "رسائل البريد الإلكتروني الخاصة بالدعم - اسمح لهذا المستخدم بفتح تذاكر في حسابك.",
  "billing_contacts_terms": "لقد قرأت ووافقت على \"سياسة الخصوصية\" و\"الشروط والأحكام\"",
  "billing_contacts_title": "اضف جهات اتصال",
  "billing_contacts_transactional": "رسائل البريد الإلكتروني العامة - الإعلانات العامة وتذكيرات كلمة المرور",
  "billing_contacts_zip": "الرمز البريدي",
  "billing_details_contact_above": "أرسل فقط إلى جهة الاتصال الافتراضية",
  "billing_emails_sentdate": "تاريخ الإرسال",
  "billing_emails_subject": "موضوع",
  "billing_invoice_date": "تاريخ إرسال",
  "billing_invoice_duedate": "تاريخ الاستحقاق",
  "billing_invoice_number": "رقم",
  "billing_invoice_status": "حالة",
  "billing_invoice_status_cancelled": "ملغاه",
  "billing_invoice_status_paid": "مدفوعة",
  "billing_invoice_status_refunded": "مستردة",
  "billing_invoice_status_unpaid": "غير مدفوعة",
  "billing_invoice_total": "مجموع",
  "billing_product_payment_method_banktransfer": "تحويل بنكي",
  "billing_product_paymentmethod_avangate": "بطاقة الائتمان (Verizon former 2Checkout)",
  "billing_product_paymentmethod_stripe": "بطاقة الائتمان (Stripe)",
  "button_add_contact": "إضافة جهة اتصال",
  "button_add_filter": "أضف عامل تصفية",
  "button_add_plan": "اطلب خطة جديدة",
  "button_add_subaccount": "إضافة حساب فرعي",
  "button_add_suppression": "قم بإضافة القمع",
  "button_add_template": "أضف قالبًا",
  "button_addbcc": "أضف نسخة مخفية الوجهة",
  "button_addfooter": "إضافة تذييل",
  "button_advanced_search": "البحث المتقدم",
  "button_apply": "تطبيق",
  "button_back": "خلف",
  "button_basic_search": "البحث الأساسي",
  "button_buycredits": "شراء إئتمانات",
  "button_cancel": "يلغي",
  "button_close": "يغلق",
  "button_contact_us": "اتصل بنا",
  "button_create": "خلق",
  "button_createalert": "إنشاء تنبيه",
  "button_delete": "حذف",
  "button_delete_all": "حذف الكل",
  "button_delete_filtered": "حذف المصفاة",
  "button_delete_selected": "حذف المحدد ({n})",
  "button_edit": "يحرر",
  "button_export": "يصدر",
  "button_import": "استيراد ملف",
  "button_limits": "ضع الحدود",
  "button_more": "أكثر",
  "button_next": "التالي",
  "button_refresh": "ينعش",
  "button_request_cancellation": "طلب الغاء",
  "button_reset": "إعادة ضبط",
  "button_returnlist": "العودة إلى القائمة",
  "button_save": "يحفظ",
  "button_search": "بحث",
  "button_select_fromdevice": "حدد الملفات من جهازك",
  "button_unsubscribe": "إضافة رابط إلغاء الاشتراك",
  "button_update": "تحديث",
  "button_update_template": "تحديث النموذج",
  "button_update_unsubscribe": "تحديث رابط إلغاء الاشتراك",
  "button_updatealert": "تنبيه التحديث",
  "button_updatebcc": "تحديث نسخة مخفية الوجهة",
  "button_updatefooter": "تحديث التذييل",
  "confirm_password_is_missing": "تأكيد كلمة المرور إلزامي.",
  "dashboard_clicked": "تم النقر",
  "dashboard_delivered": "تم التوصيل",
  "dashboard_emails_sent": "تم إرسال رسائل البريد الإلكتروني",
  "dashboard_emails_sent_out_of": "رسائل البريد الإلكتروني المرسلة من",
  "dashboard_gotoanalytics": "انتقل إلى Analytics",
  "dashboard_new_version": "نسخة محدثة متاحة!",
  "dashboard_new_version_cancel": "نعم",
  "dashboard_new_version_description": "احفظ عملك أولاً ثم أعد تحميل الصفحة <br> أو اضغط على'\"تحديث الآ'\" لتحميل نسخة جديدة.",
  "dashboard_new_version_ok": "تحديث الان",
  "dashboard_plan_emails": "رسائل البريد الإلكتروني",
  "dashboard_plan_label": "يخطط",
  "dashboard_plan_label_interval": "{interval} خطة",
  "dashboard_plan_limit_unit_daily": "يوم",
  "dashboard_plan_limit_unit_monthly": "شهر",
  "dashboard_plan_limit_unit_yearly": "عام",
  "dashboard_recent_email_activities": "أنشطة البريد الإلكتروني الأخيرة",
  "dashboard_try": "أنت تستخدم \"نسخة تجريبية مجانية\". لعرض لوحة القيادة الكاملة:",
  "datepicker_last_3_months": "آخر 3 أشهر",
  "datepicker_last_30days": "آخر 30 يومًا",
  "datepicker_last_month": "الشهر الماضي",
  "datepicker_last_sevendays": "اخر 7 ايام",
  "datepicker_last_week": "الأسبوع الماضي",
  "datepicker_last_year": "العام الماضي",
  "datepicker_this_month": "هذا الشهر",
  "datepicker_this_year": "هذه السنة",
  "datepicker_today": "اليوم",
  "datepicker_yesterday": "في الامس",
  "delete_all_bounce": "حذف جميع حالات الارتداد",
  "delete_all_manual": "حذف كل دليل",
  "delete_all_spam": "احذف جميع الرسائل غير المرغوب فيها",
  "delete_all_unsubscribe": "حذف جميع الإشتراكات",
  "delete_fist_login_dont": "لا تريني هذه الرسالة مرة أخرى.",
  "delete_fist_login_one": "<h3> مرحبًا بك في لوحة التحكم المتقدمة لـ turboSMTP. </h3> <p> اعرض الإحصائيات في الوقت الفعلي حول حملات البريد الإلكتروني الخاصة بك <br> وقم بتحسين نتائجك باستخدام الأدوات الاحترافية. </ p> <h4> يرجى اتباع التعليمات للتهيئة لوحتك. </ h4>",
  "delete_fist_login_three_a": "يرجى وضع اسم خادم SMTP في عميل البريد الخاص بك.",
  "delete_fist_login_three_b": "<p> <strong class = \"font-xxl\"> pro.turbo-smtp.com </strong> </p>",
  "delete_fist_login_three_c": "لا تنس اعداد سجلات ال DNS الخاصة بنطاقك <br> ابحث عن المتغيرات في \"الإعدادات\".",
  "delete_fist_login_two_a": "<h3> فتح التتبع </ h3> <p> يتيح لـ turboSMTP تتبع معدلات فتح رسائلك. </ p>",
  "delete_fist_login_two_b": "<h3> تتبع النقرات </ h3> <p> يتيح لـ turboSMTP تتبع معدلات نقر رسائلك. </ p>",
  "editor_quill_button_title": "إظهار مصدر HTML",
  "editor_quill_cancel_text": "يلغي",
  "editor_quill_msg": "قم بتحرير المحتوى بتنسيق HTML",
  "editor_quill_ok_text": "نعم",
  "emails_month": "رسائل البريد الإلكتروني / الشهر",
  "emailvalidator_add_file": "اضف ملف",
  "emailvalidator_add_form_errors": "أخطاء النموذج",
  "emailvalidator_add_form_nofile_selected": "لم يتم اختيار اي ملف",
  "emailvalidator_add_value": "يمكنك إضافة بين",
  "emailvalidator_attention": "انتباه!",
  "emailvalidator_available": "ائتمانات مجانية",
  "emailvalidator_balance_description": "رصيدك الائتماني هو",
  "emailvalidator_balance_title": "رصيد التحقق الخاص بك",
  "emailvalidator_buy_extra_credit": "شراء رصيد إضافي",
  "emailvalidator_complete": "اكتمال",
  "emailvalidator_confirm_delete_label": "تأكيد العمل",
  "emailvalidator_confirm_delete_text": "هل تريد حقًا حذف هذه القائمة؟",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/en/submitticket.php\" target=\"_blank\"> الاتصال بالدعم <i class =\"ml-2 pi pi-external-link\"> </i> </ a >",
  "emailvalidator_cost_per_email": "تكلفة البريد الإلكتروني هي",
  "emailvalidator_date": "تاريخ الإنشاء:",
  "emailvalidator_day": "يوم",
  "emailvalidator_details_empty": "لا توجد عناصر بالداخل",
  "emailvalidator_domain": "اختصاص",
  "emailvalidator_domain_age": "عمر المجال",
  "emailvalidator_email": "بريد الالكتروني",
  "emailvalidator_email_addesses": "عناوين البريد الإلكتروني",
  "emailvalidator_empty": "يجب أن يحتوي الملف الذي تم تحميله على عنوان بريد إلكتروني واحد فقط في كل سطر. تنسيقات الملفات المسموح بها هي csv و txt. أو حدد ملفًا للتحميل.",
  "emailvalidator_entry_details": "تفاصيل التحقق",
  "emailvalidator_error": "خطأ",
  "emailvalidator_error_contact_support": "خطأ: اتصل بالدعم!",
  "emailvalidator_expiring": "تنتهي في",
  "emailvalidator_export": "يصدر",
  "emailvalidator_free_email": "بريد إلكتروني مجاني",
  "emailvalidator_how_many": "كم عدد رسائل البريد الإلكتروني التي تريد التحقق من صحتها؟",
  "emailvalidator_list_contains": "تحتوي القائمة التي تم تحميلها على ملفات",
  "emailvalidator_list_not_removed": "خطأ في إزالة القائمة",
  "emailvalidator_list_removed": "تمت إزالة القائمة بنجاح.",
  "emailvalidator_mx_record": "سجل MX",
  "emailvalidator_please_enter_amout": "الرجاء إدخال المبلغ الذي تريد إضافته إلى محفظتك الافتراضية.",
  "emailvalidator_price_calculator": "حاسبة السعر",
  "emailvalidator_price_email": "السعر لكل بريد إلكتروني",
  "emailvalidator_process_now": "العملية الآن",
  "emailvalidator_refresh": "تحديث",
  "emailvalidator_slide_description": "يجب أن يكون الملف عمودًا واحدًا يحتوي على جميع عناوين البريد الإلكتروني التي تريد استيرادها.",
  "emailvalidator_slide_details_description": "تنسيقات الملفات المسموح بها هي csv أو txt.",
  "emailvalidator_slide_details_title": "قم بسحب وإسقاط ملفك هنا.",
  "emailvalidator_slide_manually_description": "انسخ والصق عناوين بريد إلكتروني متعددة في المنطقة أدناه ، مفصولة بخط نهاية.",
  "emailvalidator_slide_manually_title": "إضافة يدويا",
  "emailvalidator_smpt_provider": "مزود SMTP",
  "emailvalidator_status": "حالة",
  "emailvalidator_status_abuse": "سئ",
  "emailvalidator_status_catch_all": "جامع كل شيء",
  "emailvalidator_status_do_not_mail": "لا ترسل بريد",
  "emailvalidator_status_invalid": "غير صالح",
  "emailvalidator_status_spamtrap": "رسائل إلكترونية مزعجة",
  "emailvalidator_status_unknown": "مجهول",
  "emailvalidator_status_valid": "صالح",
  "emailvalidator_title": "مدقق البريد الإلكتروني",
  "emailvalidator_total_cost": "التكلفة الإجمالية",
  "emailvalidator_upload_warning": "رصيدك الائتماني الحالي هو {current_balance} يلزمك شراء {required_balance} من الرصيد الإضافي للتحقق من صحة هذه القائمة ...,  ",
  "emailvalidator_validate_list": "قائمة التحقق",
  "emailvalidator_validate_now": "تحقق الآن",
  "emailvalidator_validated_lists": "قوائم تم التحقق من صحتها",
  "emailvalidator_validation_date": "تاريخ الصلاحية",
  "emailvalidator_value": "قيمة",
  "emailvalidator_you_have": "لديك",
  "empty_authorization_token": "رمز التفويض مفقود",
  "empty_request_body": "الطلب غير مكتمل",
  "error": "خطأ",
  "file_too_large": "file_too_large",
  "filter": "منقي",
  "filter_by": "مصنف بواسطة",
  "filter_fuzzy": "البحث الذكي",
  "filter_fuzzy_description": "قم بتمكين هذه الميزة لإرجاع عناصر مماثلة لمصطلح البحث.",
  "filter_placeholder_analytics": "بحث...",
  "filter_placeholder_suppressions": "بحث...",
  "filter_suppressions_placeholder": "ابحث عن طريق المستلم أو المرسل أو موضوع البريد الإلكتروني أو سبب الإلغاء.",
  "filters_show": "إظهار المرشحات",
  "filters_hide": "إخفاء عوامل التصفية",
  "first_login_step": "الخطوة {ن}",
  "forgot_password_changed": "كلمة السر الخاصة بك تم تغييرها بنجاح.",
  "forgot_password_click": "انقر هنا",
  "forgot_password_confirm": "أكد رقمك السري",
  "forgot_password_done": "منجز!",
  "forgot_password_donot_match": "كلمة المرور غير مطابقة.",
  "forgot_password_email_not_found": "عنوان البريد الإلكتروني غير موجود",
  "forgot_password_enter_email": "أدخل عنوان بريدك الالكتروني",
  "forgot_password_error": "حدث خطأ أثناء تغيير كلمة المرور الخاصة بك.",
  "forgot_password_expired": "انتهت صلاحية البريد الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك.",
  "forgot_password_pick": "اختار كلمه سر",
  "forgot_password_please_reset": "يرجى تعيين كلمة المرور الخاصة بك",
  "forgot_password_recovery_email_sent": "تم إرسال البريد الإلكتروني الخاص بالاسترداد",
  "forgot_password_resend": "لإرسال البريد الإلكتروني مرة أخرى.",
  "forgot_password_reset": "اعد ضبط كلمه السر",
  "forgot_password_send_password_reset_link": "إرسال رابط إعادة تعيين كلمة السر",
  "forgot_password_sent_email_to_update_password": "لقد أرسلنا لك بريدًا إلكترونيًا يحتوي على رابط لتحديث كلمة المرور الخاصة بك.",
  "forgot_password_set": "قم بتعيين كلمة المرور الجديدة الخاصة بك",
  "forgot_password_should_have": "يجب أن تحتوي كلمة المرور",
  "forgot_password_suggestions": "<li> حرف صغير واحد على الأقل </ li> <li> حرف كبير واحد على الأقل </ li> <li> رقم واحد على الأقل </ li> <li> 10 أحرف كحد أدنى </ li>",
  "forgot_password_switch": "لتسجيل الدخول",
  "forgot_password_switch_to_login": "لتسجيل الدخول",
  "forgot_password_token_is_missing": "رمز نسيت كلمة المرور مفقود",
  "forgot_password_unable_to_send": "غير قادر على إرسال البريد الإلكتروني.",
  "forgot_password_username": "اسم المستخدم البريد الإلكتروني",
  "forgot_password_we_will_send_you": "سنرسل لك رابط استعادة كلمة المرور.",
  "free_account": "حساب مجاني",
  "friday": "يوم الجمعة",
  "fuzzy_tooltip": "قم بتمكين هذه الميزة لإرجاع العناصر المشابهة لمصطلح البحث",
  "header_menu_support": "https://serversmtp.com/multilanguage-customer-support/",
  "internal_server_error_try_again": "حدث خطأ داخلي في الخادم. الرجاء معاودة المحاولة في وقت لاحق.",
  "invalid_authorization_token": "رمز التفويض غير صالح",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "يجب ألا تقل قيمة الحد عن 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "يجب أن تكون قيمة الصفحة 1 على الأقل",
  "invalid_value_for_orderby_parameter": "معلمة \"الترتيب حسب\" غير صالحة.",
  "invalid_value_for_the_parameter_type": "قيمة غير صالحة لنوع المعلمة",
  "invoice_not_found": "الفاتورة غير موجودة",
  "jwt_error_full_details": "تفاصيل كاملة",
  "jwt_error_status": "حالة HTTP",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "عنوان URL التالي غير موجود",
  "l_dont_have_account": "لا تملك حسابا حتى الآن؟",
  "l_email_address": "عنوان بريد الكتروني",
  "l_forgot_password": "هل نسيت كلمة السر؟",
  "l_login": "تسجيل الدخول",
  "l_password": "كلمة المرور",
  "l_remember_me": "أبقني متصل.",
  "l_sign_up_here": "سجل هنا",
  "l_username_email": "اسم المستخدم البريد الإلكتروني",
  "l_welcome_back": "مرحبا بعودتك",
  "language_changed_label": "لقد قمت بتغيير اللغة",
  "language_changed_message": "لتطبيق تغييرات اللغة ، أعد تحميل الصفحة",
  "language_changed_reload": "إعادة تحميل",
  "m_accountinfo": "معلومات الحساب",
  "m_analytics": "تحليلات",
  "m_billing": "فواتير شكلية",
  "m_dashboard": "لوحة القيادة",
  "m_emailsentout": "تم إرسال رسائل البريد الإلكتروني",
  "m_emailvalidator": "مدقق البريد الإلكتروني",
  "m_messages": "رسائل النظام",
  "m_myaccount": "حسابي",
  "m_mydetails": "حسابي",
  "m_noplans": "لا يوجد خطط",
  "m_of": "من",
  "m_products": "منتجاتي",
  "m_savechanges": "احفظ التغييرات",
  "m_settings": "إعدادات",
  "m_subaccounts": "الحسابات الفرعية",
  "m_suppressions": "القمع",
  "m_tickets": "تذاكري",
  "m_validuntil": "صالح حتى",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "تم توفير قيمة مفقودة أو غير صالحة لسجلات DNS (نظام التعرف على هوية المرسل (SPF) و / أو DKIM). يرجى مراجعة إعدادات DNS الخاصة بك.",
  "missing_required_parameter": "المعلمة المطلوبة مفقودة",
  "missing_required_parameter_email": "البريد الإلكتروني مفقود",
  "missing_required_parameter_from": "تفاصيل \"من\" مفقودة",
  "missing_required_parameter_to": "تفاصيل \"إلى\" مفقودة",
  "missing_required_parameter_tz": "تفاصيل \"tz\" مفقودة",
  "modal_confirmation": "تأكيد",
  "monday": "الإثنين",
  "monthly": "شهريا",
  "my_account_title": "حسابي",
  "myaccount_2fa_title": "المصادقة الثنائية",
  "myaccount_2fa_description": "عزّز أمان حسابك بتفعيل المصادقة الثنائية (2FA). يضيف ذلك طبقة حماية إضافية لحسابك.",
  "myaccount_2fa_card_description": "فعّل المصادقة الثنائية لحماية حسابك.",
  "myaccount_2fa_select_method": "اختر طريقة المصادقة",
  "myaccount_2fa_method": "طريقة المصادقة",
  "myaccount_2fa_method_placeholder": "اختر طريقة مصادقة",
  "myaccount_2fa_otp_description": "استخدم تطبيق مصادقة (مثل Google Authenticator أو Authy) لتوليد رموز مؤقتة.",
  "myaccount_2fa_email_description": "استقبل رموز التحقق عبر البريد الإلكتروني.",
  "myaccount_2fa_sms_description": "استقبل رموز التحقق عبر الرسائل القصيرة.",
  "myaccount_2fa_none_description": "عطّل المصادقة الثنائية لحسابك.",
  "myaccount_2fa_scan_qr": "مسح رمز QR",
  "myaccount_2fa_scan_qr_description": "امسح رمز QR هذا باستخدام تطبيق المصادقة لإعداد المصادقة الثنائية.",
  "myaccount_2fa_manual_entry": "أو أدخل هذا الرمز يدويًا:",
  "myaccount_2fa_copy_secret": "نسخ إلى الحافظة",
  "myaccount_2fa_secret_copied": "تم نسخ المفتاح السري إلى الحافظة",
  "myaccount_2fa_verify_code": "تحقق من الرمز",
  "myaccount_2fa_enter_code": "أدخل رمز التحقق",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة لإتمام الإعداد.",
  "myaccount_2fa_method_updated": "تم تحديث طريقة المصادقة الثنائية بنجاح",
  "myaccount_2fa_otp_enabled": "تم تفعيل المصادقة الثنائية بنجاح",
  "myaccount_2fa_current_status": "الحالة الحالية",
  "myaccount_2fa_status": "حالة المصادقة الثنائية",
  "myaccount_2fa_status_disabled": "معطّل",
  "myaccount_2fa_error_no_keycloak_id": "تعذّر تهيئة 2FA: معرّف المستخدم غير موجود",
  "myaccount_2fa_error_invalid_code": "رمز التحقق غير صالح. يرجى المحاولة مرة أخرى.",
  "myaccount_2fa_error_generic": "حدث خطأ أثناء تهيئة المصادقة الثنائية",
  "myaccount_2fa_enabled": "مفعّل",
  "myaccount_2fa_disabled_label": "معطّل",
  "myaccount_2fa_disabled": "تم تعطيل المصادقة الثنائية بنجاح",
  "myaccount_account_details": "حسابي",
  "myaccount_billing": "فواتير شكلية",
  "myaccount_billing_contacts": "إدارة جهات الاتصال",
  "myaccount_billing_contacts_description": "سيتم إرسال جميع رسائل البريد الإلكتروني إلى العنوان الموجود في حسابك الرئيسي. أدخل المزيد من العناوين لإرسال اتصالات إلى مستلمين إضافيين.",
  "myaccount_billing_description": "يمكنك العثور في هذا القسم على الفواتير المبدئية الصادرة قبل الفواتير الضريبية. <br> سيتم إرسال الفواتير الضريبية إليك عبر البريد الإلكتروني.",
  "myaccount_billing_details": "تفاصيل الحساب والفواتير",
  "myaccount_billing_details_address": "عنوان",
  "myaccount_billing_details_address2": "العنوان 2",
  "myaccount_billing_details_billing_company_name": "شركة الفواتير",
  "myaccount_billing_details_billing_contact": "إرسال الفواتير المبدئية إلى عنوان آخر غير عنوان الحساب",
  "myaccount_billing_details_billing_vat": "ضريبة القيمة المضافة / P.IVA / C.F.",
  "myaccount_billing_details_billing_website": "موقع إلكتروني",
  "myaccount_billing_details_city": "مدينة",
  "myaccount_billing_details_country": "دولة",
  "myaccount_billing_details_description": "تغيير تفاصيل حسابك وعنوان الفواتير.",
  "myaccount_billing_details_details": "تفاصيل الفاتورة",
  "myaccount_billing_details_email": "عنوان بريد الكتروني",
  "myaccount_billing_details_fistname": "الاسم الأول",
  "myaccount_billing_details_lastname": "الكنية",
  "myaccount_billing_details_marketing": "أرغب في تلقي عروض ونصائح مخصصة من turboSMTP",
  "myaccount_billing_details_phone_number": "رقم التليفون",
  "myaccount_billing_details_policy": "قرأت و أوافق على سياسة الخصوصية و الشروط و الأحكام",
  "myaccount_billing_details_state": "المنطقة/ الولاية",
  "myaccount_billing_details_zip": "الرمز البريدى",
  "myaccount_billing_slides_description": "يمكنك ايجاد الفاتورة الأولية هنا",
  "myaccount_billing_cancellation_select_reason": "اختر سببا",
  "myaccount_billing_slides_nodata": "لم يوجد فاتورة أولية",
  "myaccount_billingcontacts_added": "تمت اضافة جهة اتصال الفاتورة بـنجاح",
  "myaccount_billingcontacts_deleted": "تم حذف جهة اتصال الفاتورة بـنجاح",
  "myaccount_billingcontacts_edited": "تم تعديل جهة الإتصال بـنجاح",
  "myaccount_billingdetails_updated": "تم تحديث تفاصيل الفواتير",
  "myaccount_change_password": "تغيير كلمة المرور",
  "myaccount_confirm_delete_selectedcontact_label": "تأكيد العمل",
  "myaccount_confirm_delete_selectedcontact_text": "هل تريد حقًا حذف جهة الاتصال هذه؟",
  "myaccount_confirm_password": "تأكيد كلمة المرور",
  "myaccount_current_password": "تحقق من كلمة المرور الحالية",
  "myaccount_language": "عرض اللغة",
  "myaccount_language_change": "تغيير اللغة",
  "myaccount_language_description": "TurboSMTP متاح الآن باللغتين الإنجليزية والإيطالية. (ستتوفر قريبًا الفرنسية والألمانية والعبرية والبرتغالية والروسية والعربية والإسبانية).",
  "myaccount_language_select": "اختار اللغة",
  "myaccount_messages": "رسائل النظام",
  "myaccount_messages_nomessages_description": "في هذا القسم ستجد الرسائل التي أرسلها نظامنا إلى حسابك.",
  "myaccount_new_password": "كلمة مرور جديدة",
  "myaccount_password_changed": "تم تغيير كلمة المرور بنجاح",
  "myaccount_password_choose": "اختر كلمة السر الجديدة",
  "myaccount_password_notmatch": "كلمات المرور هذه غير متطابقة. حاول مجددا.",
  "myaccount_password_suggestions": "يجب أن تحتوي كلمات المرور على 10 أحرف على الأقل ، بما في ذلك الأحرف الكبيرة والصغيرة ورقم واحد على الأقل.",
  "myaccount_product_delete_label": "تأكيد العمل",
  "myaccount_product_delete_text": "هل أنت متأكد أنك تريد إلغاء هذا المنتج؟",
  "myaccount_products": "منتجاتي",
  "myaccount_products_billingcycle": "دورة الفواتير",
  "myaccount_products_cycle_annually": "سنويا",
  "myaccount_products_cycle_biennally": "كل سنتين",
  "myaccount_products_cycle_free_account": "حساب مجاني",
  "myaccount_products_cycle_month": "شهريا",
  "myaccount_products_cycle_monthly": "شهريا",
  "myaccount_products_cycle_one_time": "مره واحده",
  "myaccount_products_cycle_onetime": "مره واحده",
  "myaccount_products_cycle_quarterly": "ربعي",
  "myaccount_products_cycle_semi-annually": "نصف سنوى",
  "myaccount_products_cycle_triennially": "كل ثلاث سنوات",
  "myaccount_products_cycle_year": "سنوي",
  "myaccount_products_cycle_yearly": "سنوي",
  "myaccount_products_fistpayment": "مبلغ الدفعة الأولى",
  "myaccount_products_nextduedate": "موعد الاستحقاق التالي",
  "myaccount_products_noproduct_description": "في هذا القسم ستجد المنتجات والخدمات المرتبطة بالحساب.",
  "myaccount_products_payment": "طريقة الدفع او السداد",
  "myaccount_products_price": "السعر",
  "myaccount_products_productservice": "المنتج / الخدمة",
  "myaccount_products_recurringamount": "المبلغ متكرر",
  "myaccount_products_registration": "تاريخ التسجيل",
  "myaccount_products_slide_productservice_description": "إدارة المنتج الخاص بك مباشرة من هذه المنطقة.",
  "myaccount_products_status": "حالة",
  "plans_addon_options_title": "خطط إضافية",
  "plans_available_recurring_options_title": "الخطط المتاحة",
  "plans_billing_cycle": "دورة الفوترة",
  "plans_current_plans_title": "خططك الحالية",
  "plans_cycle_month": "شهري",
  "plans_cycle_monthly": "شهري",
  "plans_cycle_onetime": "مرة واحدة",
  "plans_cycle_year": "سنوي",
  "plans_cycle_yearly": "سنوي",
  "plans_downgrade_options_title": "خيارات التخفيض",
  "plans_feature_dedicated_ip": "عنوان IP مخصص",
  "plans_feature_email_credits": "أرصدة البريد الإلكتروني",
  "plans_feature_smtp_limit": "حد SMTP",
  "plans_features": "الميزات",
  "plans_invoice_created": "تم إنشاء الفاتورة بنجاح.",
  "plans_invoice_error": "تعذر إنشاء الفاتورة. يرجى المحاولة مرة أخرى.",
  "plans_load_error": "تعذر تحميل خيارات الخطة. يرجى المحاولة مرة أخرى.",
  "plans_onetime_options_title": "خطط المرة الواحدة",
  "plans_plan_name": "اسم الخطة",
  "plans_plan_type": "نوع الخطة",
  "plans_select_plan": "اختيار الخطة",
  "plans_type_addon": "إضافة",
  "plans_type_onetime": "مرة واحدة",
  "plans_type_recurring": "متكرر",
  "plans_upgrade_options_title": "خيارات الترقية",
  "myaccount_sentdate": "تاريخ الإرسال",
  "new_dashboard_error": "عفوا لقد حصل خطأ:",
  "new_dashboard_if_you_think": "إذا كنت تعتقد أنك ترى هذه الرسالة عن طريق الخطأ ، فيرجى <a href=\"https://serversmtp.com/contact-us/\" target=\"_blank\"> الاتصال بنا </a>.",
  "new_dashboard_not_allowed": "اتصل <a href='https://serversmtp.com/contact-us/' target='_blank'> فريق الدعم </a> لبدء استخدام إصدار Beta Dashboard.",
  "new_dashboard_token_valid": "الرمز صالح",
  "new_dashboard_token_wrong": "الرمز خاطئ",
  "new_dashboard_validating": "التحقق من صحة الرمز ...",
  "no": "لا",
  "no_parameters_was_provided_for_update": "لم يتم توفير أي معلمة للتحديث",
  "no_suppression_data_were_provided": "لم يتم تقديم بيانات قمع",
  "one_time": "مره واحده",
  "optional": "اختياري",
  "or": "أو",
  "password_is_invalid": "لا يوجد حساب يطابق كلمة المرور تلك",
  "password_is_missing": "كلمة المرور مفقودة",
  "password_length_should_not_be_less_than_10_characters": "يجب أن تحتوي كلمة المرور على 10 أحرف على الأقل",
  "password_should_contain_at_least_one_uppercase_character": "يجب أن تحتوي كلمة المرور على حرف واحد على الأقل بحالة علوية",
  "password_should_contain_at_least_one_lowercase_character": "يجب أن تحتوي كلمة المرور على حرف واحد على الأقل بحالة سفلية",
  "password_should_contain_at_least_one_digit": "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
  "password_should_equals_to_confirm_password": "يجب أن تتطابق كلمة المرور مع التأكيد",
  "plan_daily": "باقة يومية",
  "plan_monthly": "باقة شهرية",
  "plan_yearly": "الباقة السنوية",
  "primeng": {
    "accept": "نعم",
    "addRule": "أضافة قاعدة",
    "after": "بعد، بعدما",
    "apply": "أضافة",
    "before": "قبل",
    "cancel": "الغاء",
    "choose": "إختار",
    "clear": "واضح",
    "contains": "يحتوي",
    "dateAfter": "التأريخ بعد",
    "dateBefore": "التأريخ قبل",
    "dateFormat": "شهر/يوم/سنة",
    "dateIs": "التأريخ هو",
    "dateIsNot": "التأريخ ليس هو",
    "dayNames": [
      "الأحد",
      "الإثنين",
      "الثلاثاء",
      "الاربعاء",
      "الخميس",
      "الجمعة",
      "السبت"
    ],
    "dayNamesMin": [
      "الأحد",
      "الإثنين",
      "الثلاثاء",
      "الاربعاء",
      "الخميس",
      "الجمعة",
      "السبت"
    ],
    "dayNamesShort": [
      "الأحد",
      "الإثنين",
      "الثلاثاء",
      "الاربعاء",
      "الخميس",
      "الجمعة",
      "السبت"
    ],
    "emptyFilterMessage": "الخيارات غير متاحة",
    "emptyMessage": "لا توجد نتيجة",
    "endsWith": "ينتهي ب",
    "equals": "يساوي",
    "firstDayOfWeek": 0,
    "gt": "أكبر من",
    "gte": "أكبر من او يساوي",
    "is": "هو",
    "isNot": "ليس",
    "lt": "أقل من",
    "lte": "اقل من او يساوي",
    "max_limit_reached": "لقد وصلت إلى الحد الأقصى لعدد الحسابات الفرعية التي يمكن تفعيلها في خطتك الحالية.",
    "matchAll": "يطابق الكل",
    "matchAny": "لا يطافق احد",
    "medium": "متوسط",
    "monthNames": [
      "كانون الثاني",
      "شباط",
      "أذار",
      "نيسان",
      "أيار",
      "حزيران",
      "تموز",
      "اب",
      "ايلول",
      "تشرين اول",
      "تشرين ثاني",
      "كانون الاول"
    ],
    "monthNamesShort": [
      "كانون الثاني",
      "شباط",
      "أذار",
      "نيسان",
      "أيار",
      "حزيران",
      "تموز",
      "اب",
      "ايلول",
      "تشرين اول",
      "تشرين ثاني",
      "كانون الاول"
    ],
    "noFilter": "لا يوجد ترشيح",
    "notContains": "لا يحتوي",
    "notEquals": "لا يساوي",
    "passwordPrompt": "أدخل كلمة السر",
    "reject": "لا",
    "removeRule": "حذف قاعدة",
    "startsWith": "يبدأ ب",
    "strong": "قوي",
    "today": "اليوم",
    "upload": "تحمّيل",
    "weak": "ضعيف",
    "weekHeader": "الأسبوع"
  },
  "saturday": "يوم السبت",
  "server_error_please_try_again": "خطأ في الخادم. الرجاء معاودة المحاولة في وقت لاحق.",
  "server_error_while_performing_update": "حدث خطأ في الخادم أثناء إجراء التحديث",
  "server_problem_gateway_timeout": "انتهت مهلة بوابة الخادم ، يرجى إعادة المحاولة.",
  "server_problem_please_retry": "مشكلة في الخادم ، يرجى إعادة المحاولة.",
  "server_problem_unknown_error": "خطأ غير معروف في الخادم ، يرجى إعادة المحاولة.",
  "settings_activities_description": "تلقي تقارير نشاط الحساب في صندوق البريد الخاص بك. يمكن أن تكون التقارير يومية وأسبوعية و / أو شهرية ، وتغطي جميع أنشطة حسابك.",
  "settings_activities_slide_dailyreport": "تقرير يومي",
  "settings_activities_slide_day": "يوم",
  "settings_activities_slide_dayoftheweek": "يوم الأسبوع",
  "settings_activities_slide_description": "يمكنك تلقي تقارير يومية وأسبوعية وشهرية لجميع أنشطة حسابك. سيتم إرسال تقريرك إلى عنوان بريدك الإلكتروني المسجل.",
  "settings_activities_slide_monthlyreport": "تقرير شهري",
  "settings_activities_slide_time": "زمن",
  "settings_activities_slide_title": "تقارير النشاط",
  "settings_activities_slide_weeklyreport": "تقرير أسبوعي",
  "settings_activities_title": "تقارير النشاط",
  "settings_alert_usage_limit": "حد الاستخدام",
  "settings_alerts_description": "تلقي تنبيه عبر البريد الإلكتروني عندما تستخدم نسبة معينة من أرصدة البريد الإلكتروني الخاص بك.",
  "settings_alerts_slide_add": "أضف تنبيه",
  "settings_alerts_slide_description": "لتجنب نفاد المرحلات في منتصف الإرسال ، استقبل تنبيهًا بالبريد الإلكتروني عندما تصل إلى نسبة مئوية محددة من اعتماداتك. نقترح تفعيل التنبيه بنسبة 80٪ من رصيدك المتاح.",
  "settings_alerts_slide_empty_description": "قم بتعيين تنبيه سيتم تسليمه إلى عنوان بريدك الإلكتروني عندما تصل إلى نسبة مئوية محددة من ائتماناتك.",
  "settings_alerts_slide_empty_title": "أضف تنبيه",
  "settings_alerts_slide_frequency": "تكرر",
  "settings_alerts_slide_percentage": "نسبة مئوية",
  "settings_alerts_slide_placeholder": "على سبيل المثال name@address.com",
  "settings_alerts_slide_sendto": "ارسل إلى",
  "settings_alerts_slide_title": "تنبيهات",
  "settings_alerts_slide_type": "نوع الانذار",
  "settings_alerts_title": "تنبيهات",
  "settings_api_description": "أرسل رسائل البريد الإلكتروني الخاصة بك مباشرة من موقع الويب الخاص بك أو التطبيق باستخدام turboSMTP API.",
  "settings_api_title": "وثائق API",
  "settings_apikeys_title": "مفاتيح واجهة برمجة التطبيقات (API Keys)",
  "settings_apikeys_description": "تعتبر مفاتيح واجهة برمجة التطبيقات وسيلة آمنة بشكل كبير لربط خدمات turboSMTP بتطبيقاتك. يمكنك إلغاء الوصول في أي وقت.",
  "settings_apikeys_slide_title": "مفاتيح واجهة برمجة التطبيقات",
  "settings_apikeys_slide_description": "قم بإدارة مفاتيح واجهة برمجة التطبيقات الخاصة بك. يظهر هذا الجدول جميع مفاتيح واجهة برمجة التطبيقات النشطة. يمكنك إنشاء مفاتيح جديدة أو حذف المفاتيح الحالية لإلغاء وصولها.",
  "settings_apikeys_slide_empty_title": "إنشاء مفتاح واجهة برمجة التطبيقات",
  "settings_apikeys_slide_empty_description": "تتألف مفاتيح واجهة برمجة التطبيقات من Consumer Secret و Consumer Keys. إنها بيانات اعتماد البرنامج التي تسمح لبرنامج بالوصول إلى حساب turboSMTP الخاص بك دون استخدام اسم المستخدم وكلمة المرور الخاصة بك. إنها آمنة للغاية ويمكن إلغاءها في أي وقت دون تغيير بيانات تسجيل الدخول إلى لوحة تحكم turboSMTP الخاصة بك.",
  "settings_apikeys_slide_add": "إنشاء مفتاح واجهة برمجة التطبيقات",
  "settings_apikeys_slide_add_description": "اختر اسمًا توضيحيًا لمفتاح واجهة برمجة التطبيقات الخاص بك.",
  "settings_apikeys_apikey_name": "الاسم",
  "settings_apikeys_slide_label_info": "هذا الاسم هو للإشارة فقط. لن تحتاج إلى إدخال الاسم في تطبيقاتك.",
  "settings_apikeys_apikey_key": "مفتاح المستهلك Consumer Key",
  "settings_apikeys_apikey_creationtime": "وقت الإنشاء",
  "settings_apikeys_apikey_name_label": "اسم مفتاح واجهة برمجة التطبيقات",
  "settings_apikeys_apikey_name_placeholder": "قم بتعيين اسم مفتاح واجهة برمجة التطبيقات الخاص بك",
  "settings_apikeys_apikey_revoke_alt": "حذف وإلغاء الوصول",
  "settings_apikeys_apikey_confirm_revoke_label": "حذف وإلغاء الوصول لمفتاح واجهة برمجة التطبيقات",
  "settings_apikeys_apikey_confirm_revoke_text": "حذف مفتاح واجهة برمجة التطبيقات '{name}'؟<br> سيؤدي ذلك إلى إلغاء الوصول لجميع التطبيقات التي تستخدم هذا المفتاح.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "تأكيد",
  "settings_apikeys_apikey_confirm_revoke_cancel": "إلغاء",
  "settings_apikeys_apikey_revoked": "تم إلغاء مفتاح واجهة برمجة التطبيقات بنجاح",
  "settings_apikeys_apikey_consumerkey_button_add": "إنشاء مفتاح واجهة برمجة التطبيقات",
  "settings_apikeys_apikey_new_success": "تم إنشاء مفتاح واجهة برمجة التطبيقات!",
  "settings_apikeys_apikey_consumer": "مفتاح المستهلك Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "يتم عرض هذا <strong>Consumer Secret</strong> هنا فقط. <strong>انسخه الآن واحتفظ به بأمان<strong/>. إذا فقدت هذا المفتاح، ستحتاج إلى حذفه وإنشاء مفتاح جديد",
  "settings_bccs_description": "سيتلقى كل عنوان بريد إلكتروني في قائمة BCC نسخة من كل بريد إلكتروني دون أن يرى المستلم تفاصيل المستلمين الآخرين.",
  "settings_bccs_enable": "تمكين تفويض حساب بريد إلكتروني واحد أو أكثر لتلقي نسخة من أي رسائل بريد إلكتروني تم إرسالها.",
  "settings_bccs_slide_add": "أضف BCCs",
  "settings_bccs_slide_description": "يرجى تعيين حساب بريد إلكتروني أو أكثر وتفويضه لتلقي نسخة من أي رسائل بريد إلكتروني.",
  "settings_bccs_slide_email": "بريد الالكتروني",
  "settings_bccs_slide_empty": "يرجى تعيين حساب بريد إلكتروني واحد وتفويضه لتلقي نسخة من أي رسائل بريد إلكتروني.",
  "settings_bccs_slide_empty_title": "أضف عنوان BCC",
  "settings_bccs_slide_name": "اسم",
  "settings_bccs_slide_not_verified": "لم يتم التحقق منها",
  "settings_bccs_slide_status": "حالة",
  "settings_bccs_slide_title": "BCCs (نسخة كربونية غير مرئية)",
  "settings_bccs_slide_verified": "تم التحقق",
  "settings_bccs_title": "BCCs (نسخة كربونية غير مرئية)",
  "settings_bounces_description": "يؤدي تمكين إعلامات الارتداد إلى إرسال إشعارات إلينا حول رسائل البريد الإلكتروني المرتدة. لتلقي جميع إشعارات الارتداد بنفسك ، قم بتعطيل هذا الخيار.",
  "settings_bounces_title": "إدارة الارتداد",
  "settings_click_tracking": "انقر فوق تعقب",
  "settings_click_tracking_description": "انقر فوق تتبع يسجل جميع النقرات التي تم إجراؤها على كل رابط في رسائل البريد الإلكتروني الخاصة بك.",
  "settings_dns_bar_description": "يجب إضافة سجلات SPF و DKIM إلى جميع نطاقات عناوين البريد الإلكتروني للمرسل.",
  "settings_dns_bar_dkim_description": "يمكن إضافة سجل DKIM كسجل TXT بإدراج ما يلي:",
  "settings_dns_bar_dkim_title": "سجلات DKIM",
  "settings_dns_bar_domainaut": "مصادقة المجال",
  "settings_dns_bar_domainaut_description": "السماح لـ TurboSMTP بإرسال رسائل البريد الإلكتروني نيابة عنك.",
  "settings_dns_bar_spf_description": "أضف سجل TXT التالي إلى مجال عنوان المغلف (example.com) ، في إحدى الحالتين التاليتين:",
  "settings_dns_bar_spf_description_a": "<strong>إذا كان هناك سجل SPF موجود بالفعل في إعدادات DNS لنطاقك</strong>، فستحتاج إلى تعديله. ببساطة أدخل",
  "settings_dns_bar_spf_description_b": "مباشرة بعد الجزء",
  "settings_dns_bar_spf_description_c": "تذكر أن تترك فراغًا قبل وبعد هذه الإضافة للحفاظ على الصيغة الصحيحة.",
  "settings_dns_bar_spf_description_d": "<strong>في حال عدم وجود سجل SPF قائم</strong>، تابع لإنشاء واحد عن طريق إدخال المعلومات اللازمة في سجل TXT جديد ضمن إعدادات DNS الخاصة بك (لا حاجة لتحديد نطاق SPF إلا إذا لزم الأمر):",
  "settings_dns_bar_spf_title": "سجل نظام التعرف على هوية المرسل (SPF)",
  "settings_dns_bar_title": "إعدادات DNS",
  "settings_dns_description": "أضف سجلات DNS الخاصة بنا إلى نطاقك لتوقيع رسائل البريد الإلكتروني الخاصة بك باستخدام DKIM وضمان التسليم الأمثل.",
  "settings_dns_title": "سجلات DNS",
  "settings_email_body_tip": "الرجاء تحديد <٪ body٪> في الإدخال.",
  "settings_email_elements": "عناصر البريد الإلكتروني",
  "settings_email_footers_added": "تمت إضافة التذييل بنجاح",
  "settings_email_footers_confirm_delete_label": "تأكيد العمل",
  "settings_email_footers_confirm_delete_text": "هل تريد حقًا حذف هذا التذييل؟",
  "settings_email_footers_default": "تم تحديث إعدادات التذييل بنجاح",
  "settings_email_footers_removed": "تمت إزالة التذييل بنجاح",
  "settings_email_footers_updated": "تم تحديث التذييل بنجاح",
  "settings_email_name_tip": "الرجاء تحديد اسم",
  "settings_email_templates_added": "تمت إضافة القالب بنجاح",
  "settings_email_templates_confirm_delete_label": "تأكيد العمل",
  "settings_email_templates_confirm_delete_text": "هل تريد حقًا حذف هذا النموذج؟",
  "settings_email_templates_default": "تم تحديث إعدادات القوالب بنجاح",
  "settings_email_templates_removed": "تمت إزالة القالب بنجاح",
  "settings_email_templates_updated": "تم تحديث النموذج بنجاح",
  "settings_email_unsub_added": "تمت إضافة رابط إلغاء الاشتراك بنجاح",
  "settings_email_unsub_confirm_delete_label": "تأكيد العمل",
  "settings_email_unsub_confirm_delete_text": "هل تريد حقًا حذف رابط إلغاء الاشتراك هذا؟",
  "settings_email_unsub_removed": "تمت إزالة رابط إلغاء الاشتراك بنجاح",
  "settings_email_unsub_updated": "تم تحديث رابط إلغاء الاشتراك بنجاح",
  "settings_footers_description": "إضافة تذييل لرسائل البريد الإلكتروني الخاصة بك.",
  "settings_footers_slide_add": "إضافة تذييل",
  "settings_footers_slide_convert": "HTML إلى نص",
  "settings_footers_slide_description": "انقر على \"إضافة تذييل\" أو قم بتحرير تذييل موجود ، ثم أدخل اسم التذييل وأكمل الحقول باستخدام HTML أو نص عادي.",
  "settings_footers_slide_empty_description": "انقر على \"إضافة تذييل\" أو قم بتحرير تذييل موجود ، ثم أدخل اسم التذييل وأكمل الحقول باستخدام HTML أو نص عادي.",
  "settings_footers_slide_empty_title": "لا تذييلات",
  "settings_footers_slide_htmltext": "نص HTML",
  "settings_footers_slide_name": "اسم",
  "settings_footers_slide_plaintext": "نص عادي",
  "settings_footers_slide_title": "التذييلات",
  "settings_footers_title": "التذييلات",
  "settings_ga_bar_description": "يرجى إكمال الحقول التالية ، بما في ذلك اسم ومصدر بيانات حملتك ، لتنشيط تكامل Google Analytics.",
  "settings_ga_bar_title": "تحليلات جوجل",
  "settings_ga_content": "محتوى الحملة",
  "settings_ga_content_mandatory": "محتوى الحملة إلزامي",
  "settings_ga_integrate": "ادمج تحليلات جوجل لتتبع معدلات التحويل والبيانات الأخرى",
  "settings_ga_medium": "وسيط الحملة",
  "settings_ga_medium_mandatory": "وسيط الحملة إلزامي",
  "settings_ga_name": "اسم الحملة",
  "settings_ga_name_mandatory": "اسم الحملة إلزامي",
  "settings_ga_parameters": "حدود",
  "settings_ga_parameters_description": "يرجى إكمال الحقول التالية ، بما في ذلك اسم ومصدر بيانات حملتك ، لتنشيط تكامل Google Analytics.",
  "settings_ga_source": "مصدر الحملة",
  "settings_ga_source_mandatory": "مصدر الحملة إلزامي",
  "settings_ga_term": "مصطلح الحملة",
  "settings_ga_term_mandatory": "مصطلح الحملة إلزامي",
  "settings_google_analytics_description": "Google Analytics يتتبع معدلات التحويل والبيانات الأخرى.",
  "settings_google_analytics_title": "تحليلات جوجل",
  "settings_integrations": "تكاملات",
  "settings_integrations_dkim_updated": "تم تحديث إعدادات DKIM بنجاح",
  "settings_notification_alert_confirm_delete_label": "تأكيد العمل",
  "settings_notification_alert_confirm_delete_text": "هل تريد حقًا حذف هذا التنبيه؟",
  "settings_notification_bcc_confirm_delete_label": "تأكيد العمل",
  "settings_notification_bcc_confirm_delete_success": "تم حذف BCC {email} بنجاح.",
  "settings_notification_bcc_confirm_delete_text": "هل تريد حقًا حذف {البريد الإلكتروني} هذا BCC؟",
  "settings_notification_smtp_auth": "مصادقة SMTP",
  "settings_notifications": "إشعارات",
  "settings_notifications_alert_added": "تم إنشاء التنبيه بنجاح",
  "settings_notifications_alert_deleted": "تم حذف التنبيه بنجاح.",
  "settings_notifications_alert_updated": "تم تحديث التنبيه بنجاح",
  "settings_notifications_bcc_emailbox": "لقد أرسلنا للتو رسالة تحقق إلى <{email}>.",
  "settings_notifications_bcc_update_success": "تم تحديث BCC {email} بنجاح.",
  "settings_notifications_smtp_auth_enabled": "ممكن",
  "settings_notifications_smtp_host": "",
  "settings_notifications_smtp_host_eu": "",
  "settings_notifications_smtp_passvalue": "*********<br>(كلمة المرور التي قدمتها عند التسجيل)",
  "settings_notifications_smtp_password": "كلمة مرور SMTP",
  "settings_notifications_smtp_ports": "منافذ SMTP",
  "settings_notifications_smtp_server": "خادم SMTP",
  "settings_notifications_smtp_username": "اسم مستخدم SMTP",
  "settings_open_tracking": "فتح التتبع",
  "settings_open_tracking_description": "سيؤدي تمكين التتبع المفتوح إلى إنشاء سجل للرسائل المفتوحة ، مما يتيح لك تتبع نتائج الحملة بشكل أفضل.",
  "settings_setting_changed": "تم تغيير الإعداد {الخدمة}",
  "settings_setting_disabled": "الإعداد معطل {الخدمة}",
  "settings_setting_enabled": "تمكين الإعداد {الخدمة}",
  "settings_setting_notdisabled": "لا يمكن تفعيل إعداد {الخدمة}.",
  "settings_setting_notenabled": "لا يمكن تفعيل إعداد {الخدمة}.",
  "settings_setting_webhook_notenabled": "تتوفر أدوات ربط الويب لإعلام الأحداث في خطط PRO المتكررة فقط.",
  "settings_smtp_description": "للاتصال عبر SMTP ، قم بتهيئة SMTP في عميل البريد الخاص بك أو في أي تطبيق بريد آخر عن طريق إضافة المعلمات التالية. انقر فوق الزر \"المزيد\" لرؤية المعلمات.",
  "settings_smtp_slide_description": "هيئ SMTP في عميل البريد الخاص بك ، أو في أي تطبيق بريد آخر ، عن طريق إضافة المعلمات التالية.",
  "settings_smtp_slide_description_api": "اسم المستخدم وكلمة المرور لمصادقة SMTP هما زوج من مفاتيح API: استخدم Consumer Key كاسم مستخدم SMTP وConsumer Secret ككلمة مرور SMTP. اعتبرهما بيانات اعتماد يجب الحفاظ على سريتها وتدويرها عند الحاجة.",
  "settings_smtp_slide_parameter": "معامل",
  "settings_smtp_slide_title": "الاتصال عبر SMTP",
  "settings_smtp_slide_value": "قيمة",
  "settings_smtp_title": "الاتصال عبر SMTP",
  "settings_template_description": "القوالب هي الأداة المثالية لمنح بريدك الإلكتروني تخطيطًا فعالاً بسهولة.",
  "settings_template_slide_add": "أضف نموذجًا",
  "settings_template_slide_default": "إفتراضي",
  "settings_template_slide_description": "انقر فوق \"إضافة نموذج\" وأكمل الحقول بالمعلومات المطلوبة ، بما في ذلك اسم النموذج و HTML أو نص عادي.",
  "settings_template_slide_empty_description": "انقر فوق \"إضافة نموذج\" وأكمل الحقول بالمعلومات المطلوبة ، بما في ذلك اسم النموذج و HTML أو نص عادي.",
  "settings_template_slide_empty_title": "أضف قالبًا",
  "settings_template_slide_html": "نسخة HTML",
  "settings_template_slide_info": "<٪ body٪> إلزامي في نص HTML والنص العادي. سيتم استبدال العنصر النائب بمحتوى حقيقي.",
  "settings_template_slide_name": "اسم القالب",
  "settings_template_slide_plaintext": "نسخة نص عادي",
  "settings_template_slide_title": "القوالب",
  "settings_template_title": "القوالب",
  "settings_title": "إعدادات",
  "settings_tracking": "تتبع",
  "settings_unsubscribe_description": "أضف رابط إلغاء الاشتراك إلى الجزء السفلي من الرسائل النصية ورسائل البريد الإلكتروني بتنسيق HTML. لن يتم تسليم رسائل البريد الإلكتروني للمستخدمين غير المشتركين.",
  "settings_unsubscribe_select": "اختر لغة",
  "settings_unsubscribe_slide_add": "أضف رابط إلغاء الاشتراك",
  "settings_unsubscribe_slide_description": "أضف رابط إلغاء الاشتراك إلى الجزء السفلي من الرسائل النصية ورسائل البريد الإلكتروني بتنسيق HTML. لن يتم تسليم رسائل البريد الإلكتروني للمستخدمين غير المشتركين. سيتم التعامل مع عمليات إلغاء الاشتراك تلقائيًا وفي الوقت الفعلي لتحسين سمعتك البريدية. أدخل النص الذي تريد استخدامه (مثل \"لإلغاء الاشتراك ، انقر هنا\") ثم الصق النص في العنصر النائب في رسالتك.",
  "settings_unsubscribe_slide_empty": "إضافة ارتباط إلغاء الاشتراك",
  "settings_unsubscribe_slide_empty_description": "أضف رابط إلغاء الاشتراك إلى الجزء السفلي من الرسائل النصية ورسائل البريد الإلكتروني بتنسيق HTML. لن يتم تسليم رسائل البريد الإلكتروني للمستخدمين غير المشتركين. سيتم التعامل مع عمليات إلغاء الاشتراك تلقائيًا وفي الوقت الفعلي لتحسين سمعتك البريدية.",
  "settings_unsubscribe_slide_language": "اختر لغة",
  "settings_unsubscribe_slide_placeholder": "نائب",
  "settings_unsubscribe_slide_text": "نص إلغاء الاشتراك",
  "settings_unsubscribe_slide_title": "رابط إلغاء الاشتراك",
  "settings_unsubscribe_text": "نص",
  "settings_unsubscribe_title": "رابط إلغاء الاشتراك",
  "settings_unsubscribe_value": "على سبيل المثال: لإلغاء الاشتراك ، انقر هنا",
  "settings_webhooks_description": "تسمح خطاطيف الويب لتطبيق الويب الخاص بك بتلقي إشعار تسليم البريد الإلكتروني وأحداث التفاعل.",
  "settings_webhooks_slide_bounced": "ارتد",
  "settings_webhooks_slide_click": "انقر",
  "settings_webhooks_slide_deferred": "مؤجل",
  "settings_webhooks_slide_delivered": "تم التوصيل",
  "settings_webhooks_slide_deliveryevents": "أحداث التسليم",
  "settings_webhooks_slide_description": "يمكنك استخدام Webhooks لإعلام الأحداث ليتم إعلامك بالأحداث التي تحدث في مشروع البريد الإلكتروني الخاص بك دون استخدام واجهات برمجة التطبيقات.",
  "settings_webhooks_slide_dropped": "إسقاط",
  "settings_webhooks_slide_engagementevents": "أحداث المشاركة",
  "settings_webhooks_slide_inserturl": "أدخل هنا عنوان url الذي تريد أن يتم إعلامك به",
  "settings_webhooks_slide_notification": "عنوان Url لإشعار Webhook",
  "settings_webhooks_slide_notification_description": "تفعيل إشعارات ربط الويب",
  "settings_webhooks_slide_open": "افتح",
  "settings_webhooks_slide_placeholder": "https: //",
  "settings_webhooks_slide_processed": "معالجتها",
  "settings_webhooks_slide_spamreport": "تقرير البريد العشوائي",
  "settings_webhooks_slide_title": "ويب هوك",
  "settings_webhooks_slide_unsubscribe": "إلغاء الاشتراك",
  "settings_webhooks_support": "يرجى الاتصال بالدعم وطلب \"تنشيط أحداث التسليم\".",
  "settings_webhooks_title": "ويب هوك",
  "settings_webhooks_upgrade": "قم بالترقية إلى باقة PRO",
  "subaccount_policy_agree": "لقد قرأت وأوافق على <a href=\"https://serversmtp.com/terms-and-conditions/\" target=\"_blank\"> شروط الخدمة </a> و <a href = \"https: // serversmtp .com / privacypolicy-eu-Regulation-2016-79-gdpr / \"target =\" _ blank \"> سياسة الخصوصية </a>",
  "subaccount_policy_agree_notchecked": "يجب أن توافق على شروط الخدمة وسياسة الخصوصية.",
  "subaccount_slide_inuse": "في الاستخدام",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "عناوين IP",
  "subaccount_slide_ips_description": "من فضلك ، حدد IP لتخصيصه لهذا الحساب الفرعي.",
  "subaccounts_action_activated": "تم تفعيل {email} بنجاح",
  "subaccounts_action_active": "نشيط",
  "subaccounts_action_deactivated": "تم تعليق {email} بنجاح",
  "subaccounts_action_delete": "حذف",
  "subaccounts_action_deleted": "تم حذف الحساب الفرعي بنجاح",
  "subaccounts_action_details": "تفاصيل",
  "subaccounts_action_edit": "يحرر",
  "subaccounts_action_limit": "ضع الحدود",
  "subaccounts_action_login": "تسجيل الدخول",
  "subaccounts_action_notdeleted": "خطأ في حذف الحساب الفرعي",
  "subaccounts_action_suspend": "تعليق",
  "subaccounts_active": "نشيط",
  "subaccounts_added_succesfully": "تمت إضافة الحساب الفرعي بنجاح",
  "subaccounts_agencysettings": "إعدادات الوكالة",
  "subaccounts_assigned_ip": "IP المعين",
  "subaccounts_changed_succesfully": "تم تغيير الحساب الفرعي بنجاح",
  "subaccounts_confirm_activation_label": "تأكيد التنشيط",
  "subaccounts_confirm_activation_text": "هل تريد تفعيل {email}؟",
  "subaccounts_confirm_deactivation_label": "تأكيد التعطيل",
  "subaccounts_confirm_deactivation_text": "هل تريد تعليق الحساب الفرعي: {email}؟",
  "subaccounts_confirm_delete_label": "تأكيد الحذف",
  "subaccounts_confirm_delete_text": "هل تريد حذف الحساب الفرعي {email}؟",
  "subaccounts_confirm_login_label": "تأكيد تسجيل الدخول",
  "subaccounts_confirm_login_text": "هل أنت متأكد أنك تريد الخروج من الحساب الحالي وتسجيل الدخول إلى {email}؟",
  "subaccounts_confirmation": "تأكيد",
  "subaccounts_create_warning": "إنشاء حسابات فرعية جديدة متاح فقط مع اشتراكات المحترفين.",
  "subaccounts_email": "حساب البريد الإلكتروني",
  "subaccounts_empty": "قم بتوسيع نطاق عملك وقدم لعملائك خدمة احترافية قابلة للتخصيص بالكامل مع علامتك التجارية ، أو قسّم رسائل البريد الإلكتروني بين موظفيك وزملائك. <br> ستسمح لك واجهة الإدارة البسيطة بمراقبة حركة المرور والإحصاءات.",
  "subaccounts_expiration_date": "تاريخ الإنتهاء",
  "subaccounts_inactive": "غير نشط",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "النشاط الاخير",
  "subaccounts_limits_nolimits": "لا حدود",
  "subaccounts_limits_sending": "حد الإرسال:\n",
  "subaccounts_limits_slide_description": "ضع حدًا لحسابك الفرعي.",
  "subaccounts_limits_slide_limits": "حدود",
  "subaccounts_limits_slide_noplan_expiration": "لا انتهاء الصلاحية",
  "subaccounts_limits_slide_plan_expiration": "انتهاء صلاحية الخطة",
  "subaccounts_limits_slide_set_plan_expiration": "تعيين انتهاء صلاحية الخطة",
  "subaccounts_limits_slide_this_number": "هذا الرقم يشير إلى فترة",
  "subaccounts_limits_slide_title": "حدود الحساب الفرعي",
  "subaccounts_no_expiration": "({master_expiration_date}) <i class =\"pi pi-info-Circle\"> </i>",
  "subaccounts_no_expiration_tooltip": "حسب انتهاء صلاحية خطة الحساب الرئيسية",
  "subaccounts_settings_update": "تم تحديث إعدادات الحساب الفرعي الآن.",
  "subaccounts_slide_account_confirm": "قم بتأكيد تفاصيل الحساب",
  "subaccounts_slide_account_description": "انقر فوق الزر \"تحرير\" لتغيير معلومات مستخدم الحساب الفرعي الخاص بك.",
  "subaccounts_slide_account_info": "معلومات الحساب",
  "subaccounts_slide_address": "عنوان",
  "subaccounts_slide_address2": "العنوان 2",
  "subaccounts_slide_change_password": "قم بتعيين كلمة مرور",
  "subaccounts_slide_city": "مدينة",
  "subaccounts_slide_company": "اسم الشركة",
  "subaccounts_slide_confirm_password": "تأكيد كلمة المرور",
  "subaccounts_slide_confirmpassword_different": "يرجى التأكد من تطابق كلمات المرور الخاصة بك.",
  "subaccounts_slide_country": "دولة",
  "subaccounts_slide_email": "عنوان بريد الكتروني",
  "subaccounts_slide_email_not_unique": "عنوان البريد الإلكتروني هذا قيد الاستخدام بالفعل.",
  "subaccounts_slide_email_required": "مطلوب عنوان البريد الإلكتروني.",
  "subaccounts_slide_first_name": "الاسم الأول",
  "subaccounts_slide_firstname_required": "الإسم الأول مطلوب.",
  "subaccounts_slide_last_name": "الكنية",
  "subaccounts_slide_lastname_required": "إسم العائلة مطلوب.",
  "subaccounts_slide_password": "كلمة المرور",
  "subaccounts_slide_password_details": "اترك حقل كلمة المرور فارغًا لمتابعة استخدام كلمة المرور الحالية.",
  "subaccounts_slide_password_minlength": "يجب أن يكون طول كلمة المرور {req} على الأقل. إنه حاليًا: {قانون}.",
  "subaccounts_slide_password_required": "كلمة المرور مطلوبة.",
  "subaccounts_slide_password_pattern": "يجب أن تحتوي كلمة المرور على 10 أحرف على الأقل، منها حرف واحد على الأقل بحالة علوية، وحرف واحد على الأقل بحالة سفلية، ورقم واحد على الأقل",
  "subaccounts_slide_phone": "هاتف",
  "subaccounts_slide_profile_information": "معلومات الملف الشخصي",
  "subaccounts_slide_region": "الولاية / المنطقة / المقاطعة",
  "subaccounts_slide_website": "موقع إلكتروني",
  "subaccounts_slide_zip": "الرمز البريدي",
  "subaccounts_status": "حالة",
  "subaccounts_subaccounts": "قائمة الحسابات الفرعية",
  "subaccounts_title": "الحسابات الفرعية",
  "subaccounts_unlimited": "<i class = 'pi pi-info-circ'> </ i> غير محدود",
  "subaccounts_unlimited_tooltip": "وفقًا لحد خطة الحساب الرئيسية.",
  "subaccounts_usage": "إستعمال",
  "sunday": "الأحد",
  "suppression_deleted": "سيتم حذف عمليات الإلغاء قريبًا.",
  "suppression_filters_reason": "سبب",
  "suppression_filters_recipient": "متلقي",
  "suppression_filters_sender": "مرسل",
  "suppression_filters_sources": "مصادر",
  "suppression_filters_subject": "موضوع البريد الإلكتروني",
  "suppression_operators_exclude": "استبعاد",
  "suppression_operators_include": "تتضمن",
  "suppression_table_addcolumn_sender": "مرسل",
  "suppression_table_dropdown_text": "من",
  "suppression_types_bounce": "ارتد",
  "suppression_types_manual": "يدوي",
  "suppression_types_spam": "رسائل إلكترونية مزعجة",
  "suppression_types_unsubscribe": "غير مشترك",
  "suppression_types_validation_failed": "فشل التحقق من الصحة",
  "suppressions_add_form_errors": "أخطاء النموذج",
  "suppressions_add_form_nofile_selected": "لم يتم اختيار اي ملف",
  "suppressions_add_suppression": "استيراد عمليات الإلغاء",
  "suppressions_choose_columns": "اختر الأعمدة",
  "suppressions_confirm_delete_all_label": "تأكيد العمل",
  "suppressions_confirm_delete_all_text": "هل تريد حقًا حذف كافة عمليات الإخماد بين <strong> {from} </strong> و <strong> {to} </strong>؟",
  "suppressions_confirm_delete_all_type_text": "هل تريد حقًا حذف <br> كافة عمليات إخماد <strong> {type} </strong> بين <strong> {from} </strong> و <strong> {to} </strong>؟",
  "suppressions_confirm_delete_filtered_label": "تأكيد العمل",
  "suppressions_confirm_delete_filtered_text": "هل تريد حقًا حذف جميع <strong> عمليات الإيقاف التي تمت تصفيتها </ strong>؟ <br> <small> * لن يتم حذف مداخل البريد العشوائي. </ small>",
  "suppressions_confirm_delete_selected_label": "تأكيد العمل",
  "suppressions_confirm_delete_selected_text": "هل تريد حقًا حذف عمليات الإخماد المحددة؟",
  "suppressions_date": "تاريخ",
  "suppressions_delete_all": "حذف الكل",
  "suppressions_delete_selected": "احذف التحديد",
  "suppressions_deleted": "سيتم حذف عمليات الإلغاء قريبًا.",
  "suppressions_description_empty": "لم يتم العثور على إدخالات للفترة المحددة.",
  "suppressions_details_date": "تاريخ",
  "suppressions_details_entry": "دخول",
  "suppressions_details_reason": "سبب",
  "suppressions_details_sender": "مرسل",
  "suppressions_details_title": "تفاصيل",
  "suppressions_details_type": "مصنف بواسطة",
  "suppressions_imported": "سيتم استيراد عمليات الإلغاء الخاصة بك قريبًا.",
  "suppressions_imported_partial": "سيتم استيراد عمليات إلغاء {import} / {total} قريبًا.",
  "suppressions_include": "تتضمن",
  "suppressions_modal_confirm": "تأكيد",
  "suppressions_not_imported": "لن يتم استيراد عمليات الإلغاء بسبب رسائل البريد الإلكتروني المشوهة.",
  "suppressions_reason": "سبب",
  "suppressions_recipient": "متلقي",
  "suppressions_title": "عمليات الإلغاء",
  "suppressions_title_empty": "لم يتم العثور على قمع",
  "suppressions_type": "اكتب",
  "t_api": "وثائق API",
  "t_knowledgebase": "قاعدة المعرفة",
  "t_logout": "تسجيل خروج",
  "table_dropdown_goto": "انتقل إلى صفحة",
  "table_dropdown_text": "{first} - {last} من {totalRecords}",
  "thursday": "يوم الخميس",
  "toggle_off": "عاجز",
  "toggle_on": "ممكن",
  "token_can_not_be_empty": "لا يمكن أن يكون الرمز المميز فارغًا",
  "token_is_missing": "الرمز مفقود",
  "tuesday": "يوم الثلاثاء",
  "unlimited": "غير محدود",
  "upload_add_manually": "إضافة يدويا",
  "upload_add_manually_description": "انسخ والصق عناوين بريد إلكتروني متعددة أو مجمعة في المنطقة أدناه ، مفصولة بخط نهاية. لتذكر سبب إضافة جهات الاتصال وللمساعدة في عمليات البحث المستقبلية ، أضف سببًا لحجب هذه العناوين.",
  "upload_add_reason": "أدخل سببًا لحجب هذه العناوين.",
  "upload_allowed_files": "تنسيقات الملفات المسموح بها هي csv أو txt.",
  "upload_dd_here": "قم بسحب وإسقاط ملفك هنا",
  "upload_import_from_file": "استيراد من ملف",
  "upload_import_from_file_description": "يجب أن يكون الملف عمودًا واحدًا يحتوي على جميع عناوين البريد الإلكتروني التي تريد استيرادها. لتذكر سبب إضافة جهات الاتصال وللمساعدة في عمليات البحث المستقبلية ، أضف سببًا لحجب هذه العناوين.",
  "warning_lang": "ستتوفر لوحة التحكم بلغتك قريبًا. في غضون ذلك ، اتصل بفريق الدعم للعودة إلى لوحة التحكم القديمة.",
  "wednesday": "الأربعاء",
  "whitelabel_agencyname": "اسم الوكالة",
  "whitelabel_companydetails": "تفاصيل الشركة",
  "whitelabel_description": "إذا فتحت حسابًا فرعيًا وكنت موزعًا رسميًا لـ turboSMTP ، فإن تخصيص المنتج بشعارك ومعلومات الشركة سيمنح العملاء تجربة علامتك التجارية.",
  "whitelabel_footer": "تذييل الوكالة",
  "whitelabel_footer_description": "أدخل كود HTML ليتم عرضه في صفحة التذييل.",
  "whitelabel_logo": "شعار الشركة",
  "whitelabel_logo_description": "الحد الأقصى لحجم الصورة المسموح به: 472 × 72 بكسل",
  "whitelabel_reset_default_image": "استعادة الصورة الافتراضية",
  "whitelabel_upload_image": "تحميل الصور",
  "whitelabel_upload_in_progress": "التحميل قيد التقدم",
  "whitelabel_website": "موقع الوكالة",
  "wrong_credentials_specified": "أوراق الاعتماد المحددة خاطئة.",
  "yes": "نعم",
  "missing_required_parameter_amount": "خانه القيمه مفقوده",
  "amount_should_be_integer": "القيمه لابد ان تكون رقم صحيح ",
  "amount_should_not_be_less_than_15": "القيمه لا يمكن ان تكون رقم اقل من ١٥",
  "amount_should_not_be_higher_than_1800": "القيمه لا يمكن ان تتعدي ١٨٠٠",
  "missing_settings_required": "يتطلب بعض الإعدادات قبل تمكينها",
  "settings_apikeys_allowed_ips": "عناوين IP المسموح بها:",
  "settings_bccs_missing_required": "يرجى التأكد من تعيين BCC واحد كافتراضي قبل تمكينه",
  "settings_bccs_notifications_default": "تم تحديث البريد الإلكتروني BCC الافتراضي بنجاح",
  "settings_link_branding_enable": "تمكين استخدام نطاقات التتبع الخاصة بك",
  "settings_link_branding_missing_required": "أضف وقم بالتحقق من نطاق واحد على الأقل قبل التنشيط",
  "settings_link_branding_title": "نطاقات التتبع المخصصة",
  "settings_link_branding_description": "استخدم نطاقاتك الخاصة لتتبع رسائلك المفتوحة وتتبع النقرات بدلاً من نطاقات turboSMTP",
  "settings_link_branding_box_alert": "لن تصبح هذه الإعدادات مفعلة إذا تم تعطيل \"تتبع رسائلك المفتوحة\" و\"تتبع النقرات\".",
  "settings_link_branding_empty_description": "انقر على \"إضافة نطاق\" واملأ الحقول بالمعلومات المطلوبة...",
  "settings_link_branding_empty_title": "إضافة نطاق التتبع",
  "settings_link_branding_add_domain": "إضافة نطاق التتبع",
  "settings_link_branding_add_domain_info": "أدخل نطاقك وقم بتعديل أي إعدادات إضافية.",
  "settings_link_branding_advanced": "خيارات متقدمة",
  "settings_link_branding_custom_subdomain": "نطاق فرعي مخصص",
  "settings_link_branding_custom_subdomain_tooltip": "الرجاء إدخال اسم نطاق صالح قبل تحديد نطاق فرعي مخصص.",
  "settings_link_branding_custom_subdomain_info": "سيقوم النظام بإنشاء نطاق فرعي عشوائي. إذا كنت ترغب في استخدام نطاق فرعي معين، أدخله هنا",
  "settings_link_branding_button_add": "إضافة نطاق التتبع",
  "settings_link_branding_match": "مطابقة نطاق التتبع مع نطاق المرسل",
  "settings_link_branding_match_sender_disabled": "تعطيل مطابقة النطاقات",
  "settings_link_branding_match_sender_enabled": "تعطيل مطابقة النطاقات",
  "settings_link_branding_filters_no_results": "لم يتم العثور على أي إدخالات بهذه المرشحات",
  "settings_link_branding_search_placeholder": "تصفية نطاقات التتبع حسب الاسم...",
  "settings_link_branding_verification_placeholder": "التحقق...",
  "settings_link_branding_verified": "تم التحقق",
  "settings_link_branding_click_to_verify": "قيد الانتظار. لم يتم الانتهاء من تكوين CNAME لهذا النطاق أو التحقق منه بعد. انقر للمتابعة...",
  "settings_link_branding_verification_success": "نجاح التحقق",
  "settings_link_branding_verification_domain_not_found": "النطاق غير موجود",
  "settings_link_branding_verification_cname_not_found": "النطاق الفرعي CNAME لـ {track_dns} غير موجود",
  "settings_link_branding_verification_auth_cname_not_found": "النطاق الفرعي CNAME لـ {auth_dns} غير موجود",
  "settings_link_branding_verification_multiple_cname_found": "تم العثور على سجلات CNAME متعددة للنطاق الفرعي {track_dns}",
  "settings_link_branding_verification_auth_multiple_cname_found": "تم العثور على سجلات CNAME متعددة للنطاق الفرعي {auth_dns}",
  "settings_link_branding_verification_incorrect_cname_target": "سجل CNAME للنطاق الفرعي {track_dns} له قيمة غير صحيحة",
  "settings_link_branding_verification_auth_incorrect_cname_target": "سجل CNAME للنطاق الفرعي {auth_dns} له قيمة غير صحيحة",
  "settings_link_branding_enabled": "مفعل",
  "settings_link_branding_disabled": "معطل",
  "settings_link_branding_not_verified": "قيد الانتظار",
  "settings_link_branding_name": "اسم النطاق",
  "settings_link_branding_enabled_no": "تعطيل نطاق التتبع",
  "settings_link_branding_enabled_yes": "تفعيل نطاق التتبع",
  "settings_link_branding_default_enabled": "تم تعيين نطاق التتبع على أنه غير مخصص",
  "settings_link_branding_default_disabled": "تم تعيين نطاق التتبع على أنه مخصص",
  "settings_link_branding_subdomain_name_invalid": "النطاق الفرعي غير صالح",
  "settings_link_branding_domain_name_invalid": "اسم النطاق غير صالح",
  "settings_link_branding_confirm_delete_label": "حذف نطاق التتبع",
  "settings_link_branding_confirm_delete_text": "هل ترغب حقًا في حذف هذا النطاق التتبع؟",
  "invalid_domain_name": "تم تقديم اسم نطاق غير صالح",
  "settings_link_branding_exclusivity_placeholder": "هل هو مخصص...",
  "settings_link_branding_exclusive": "مخصص",
  "settings_link_branding_not_exclusive": "غير مخصص",
  "settings_link_branding_domain_name": "نطاق التتبع",
  "settings_link_branding_domain_status": "الحالة",
  "settings_link_branding_added": "تمت إضافة النطاق بنجاح",
  "settings_link_branding_removed": "تمت إزالة النطاق بنجاح",
  "settings_link_branding_default_match_help": "يتم استخدام النطاقات المخصصة فقط مع نطاق المرسل المتطابق. لا يتم استخدامها أبدًا مع نطاقات المرسل غير المتطابقة",
  "settings_link_branding_dns_info": "ستحتاج إلى تثبيت السجلات التالية لاستكمال العملية.",
  "settings_link_branding_ssl_verify": "لا يمكننا التحقق مما إذا كانت مجالات SSL الخاصة بك معدة بشكل صحيح من لوحة التحكم. إذا كنت بحاجة إلى مساعدة ، يرجى الاتصال بفريق الدعم الفني لدينا.",
  "settings_link_branding_dns_wait": "قد يستغرق تغيير سجلات DNS ما يصل إلى 24 ساعة لبصبح ساري المفعول",
  "settings_link_branding_dns_info_host": "أضف هاتين السجلتين إلى قسم DNS لاستضافتك.",
  "settings_link_branding_dns_type": "النوع",
  "settings_link_branding_dns_host": "المضيف",
  "settings_link_branding_dns_host_help": "قد تشير بعض خدمات استضافة DNS إلى هذا باسم \"النطاق\" أو \"الاسم\"",
  "settings_link_branding_dns_value": "القيمة",
  "settings_link_branding_dns_value_help": "قد تشير بعض خدمات استضافة DNS إلى هذا باسم \"البيانات\"",
  "settings_link_branding_dns_help": "لست متأكدًا من كيفية القيام بذلك؟",
  "settings_link_branding_dns_help_link": "تحقق من الإرشادات",
  "settings_link_branding_dns_verification_tooltip": "يتمثل السجل CNAME في نفس الشكل لجميع النطاقات الفرعية للنطاق. يجب إضافته مرة واحدة فقط: إذا كان موجودًا بالفعل، فليس عليك إضافته",
  "settings_link_branding_verify_description": "بمجرد الإضافة، اضغط على التحقق.",
  "settings_link_branding_verify_button": "التحقق",
  "settings_link_branding_delete_info": "هل لا تحتاج إلى هذا النطاق التتبع بعد الآن؟",
  "settings_link_branding_delete_button": "حذف نطاق التتبع",
  "settings_link_branding_security_placeholder": "الأمان...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "موافق",
  "settings_link_branding_status_placeholder": "الحالة...",
  "settings_link_branding_status_enabled_no": "معطل",
  "settings_link_branding_status_enabled_yes": "نشط",
  "settings_link_branding_all_domains_disabled": "عند تعطيل أو تعليق جميع النطاقات المخصصة، ستتم استخدام روابط التتبع turboSMTP",
  "settings_link_branding_no_default_domain": "إذا قمت بتخصيص جميع روابط التتبع النشطة، فسيستخدم المرسلون الذين لديهم نطاقات معطلة أو مفقودة في هذه القائمة روابط التتبع TurboSMTP الخاصة بنا بدلاً من ذلك.",
  "settings_link_branding_match_modal_cancel": "إلغاء",
  "settings_link_branding_match_modal_confirm": "موافق",
  "settings_link_branding_match_title": "تناوب النطاق",
  "settings_link_branding_match_change": "تغيير هذا السلوك",
  "settings_link_branding_match_enabled_title": "مطابقة نطاق المرسل",
  "settings_link_branding_match_disabled_title": "عدم مطابقة نطاق المرسل",
  "settings_link_branding_match_enabled_info": "إذا كان نطاق المرسل مطابقًا لأحد نطاقات التتبع النشطة، سيتم استخدام هذا النطاق التتبع. إذا لم يتطابق نطاق المرسل مع أي نطاق تتبع، سيتم استخدام أحد نطاقات التتبع النشطة (باستثناء \"المخصصة\") بشكل عشوائي.",
  "settings_link_branding_match_disabled_info": "سيتم استخدام جميع نطاقات التتبع النشطة، بغض النظر عن نطاق المرسل.",
  "config_server_error": "تتم صيانة لوحة التحكم، ويتم إصلاحها خلال كل دقيقة",
  "feature_not_available_for_active_plan": "هذه الوظيفة غير متضمنة في بعض بياناتك",
  "forgot_password_use_different_password": "الرجاء إنشاء كلمة مرور جديدة تختلف عن الكلمات السابقة لزيادة أمان حسابك.",
  "m_getting_started": "بدء الاستخدام",
  "settings_sender_title": "التحقق من نطاقات المرسل",
  "settings_sender_add_domain": "إضافة نطاق",
  "settings_sender_description": "لتحسين تسليم البريد الإلكتروني، قم ببساطة بمصادقة نطاقات المرسل الخاصة بك باستخدام ثلاثة سجلات DNS رئيسية.",
  "settings_sender_domains_empty": "لا توجد نطاقات مرسل موثوقة بعد. <br>يرجى التحقق من نطاقك الأول.",
  "settings_sender_if_unverified": "ماذا لو لم يتم التحقق من نطاق المرسل؟",
  "settings_sender_notify_label": "أبلغني عبر البريد الإلكتروني إذا لم يتم التحقق من نطاق المرسل",
  "settings_sender_notify_email_label": "عنوان البريد الإلكتروني",
  "settings_sender_notify_email_tip": "إذا كان فارغًا، سيتم إرسال بريد الإخطار إلى عنوان حساب turboSMTP.",
  "settings_sender_notify_email_error": "يرجى إدخال عنوان بريد إلكتروني صالح",
  "settings_sender_notify_email_placeholder": "أدخل عنوان بريد إلكتروني...",
  "settings_sender_dns_title": "كيفية التحقق من نطاقك",
  "settings_sender_dns_description": "لخدمة SMTP الخاصة بنا، تحتاج إلى إعداد سجلات SPF و DKIM لنطاقات المرسل الخاصة بك. كما أن إضافة سجل DMARC أمر إلزامي لتحسين أمان البريد الإلكتروني وقابليته للتسليم.",
  "settings_sender_spf_title": "سجل SPF",
  "settings_sender_spf_description": "يرجى المتابعة عن طريق إضافة سجل TXT المحدد إلى نطاق المرسل، واختيار واحدة من البدائل التالية:",
  "settings_sender_dkim_title": "سجل DKIM",
  "settings_sender_dkim_description": "بالنسبة لـ DKIM، أضف سجل TXT المقدم إلى إعدادات DNS لنطاقك، والذي يحتوي علىpublic key المستخدم للتحقق من أن الرسائل الإلكترونية المرسلة من نطاقك شرعية ولم يتم العبث بها أثناء النقل.",
  "settings_sender_dmarc_title": "سجل DMARC",
  "settings_sender_dmarc_description": "أكمل عملية مصادقة البريد الإلكتروني عن طريق إضافة سجل DMARC TXT المعطى إلى DNS الخاص بك، مما يضع سياسة لكيفية تعامل مستقبلي البريد مع الرسائل التي لا تجتاز اختبارات SPF أو DKIM، وبالتالي توفير خطوة إضافية من الدفاع ضد الممارسات الاحتيالية للبريد الإلكتروني.",
  "settings_sender_domain_added": "تم إضافة نطاق المرسل <strong>{domain}</strong>.",
  "settings_sender_domain": "نطاق المرسل",
  "settings_sender_domains_name": "اسم النطاق",
  "settings_sender_domains_action_verify": "تحقق",
  "settings_sender_domains_action_delete": "احذف",
  "settings_sender_domains_action_subaccount": "الحساب الفرعي:",
  "settings_sender_action_delete_confirm_title": "احذف النطاق",
  "settings_sender_action_delete_confirm_message": "هل أنت متأكد أنك تريد حذف نطاق <strong>{domainName}</strong> ؟",
  "settings_sender_domain_description": "حدد نطاق المرسل الذي ترغب في التحقق منه:",
  "settings_sender_verify_record": "سجل TXT",
  "settings_sender_verify_value": "الحالة",
  "settings_sender_verify_ok": "صالح",
  "settings_sender_dns_ask_admin": "يرجى التواصل مع مدير حسابك للتحقق من النطاق. هذه العملية مطلوبة ولا يمكن أن تتم إلا بواسطة صاحب الحساب الرئيسي.",
  "settings_sender_verify_fail": "{type} غير موجود أو غير مكون بشكل صحيح",
  "settings_sender_verified": "نطاقك مكون بشكل صحيح. يمكنك إرسال باستخدام هذا المرسل بأمان.",
  "settings_sender_dkim_domain_title": "نطاق DKIM",
  "settings_sender_dkim_value_title": "قيمة DKIM",
  "settings_sender_dmarc_domain_title": "نطاق DMARC",
  "settings_sender_dmarc_value_title": "نطاق DMARC",
  "settings_sender_domains_search_placeholder": "قيمة DMARC",
  "settings_sender_domains_status_placeholder": "قم بتصفية نطاقات المرسل حسب الاسم...",
  "settings_sender_domains_status_verified": "التحقق...",
  "settings_sender_domains_status_not_verified": "موثوق",
  "settings_sender_domains_filters_no_results": "غير موثوق",
  "block_unverified_sender_title": "لم يتم العثور على إدخالات مع هذه الفلاتر",
  "block_unverified_sender_modal_title": "حظر نطاقات المرسل غير الموثوقة",
  "block_unverified_sender_desc": "نطاقات المرسل غير الموثوقة",
  "block_unverified_sender_change": "إذا لم يتم التحقق من نطاق المرسل، حظر إرسال البريد الإلكتروني وإبلاغي عبر البريد الإلكتروني",
  "forward_as_received_title": "تغيير هذا السلوك",
  "forward_as_received_info": "إرسال بدون تعديلات",
  "block_title": "رفض وإسقاط",
  "block_info": "اختر هذا الخيار لضمان عدم إرسال رسائل البريد الإلكتروني من نطاقات المرسل غير الموثوقة. سيتم إسقاط الرسائل التي تفشل في اختبارات SPF أو DKIM أو DMARC تلقائيًا للحفاظ على <strong>سمعة إرسال</strong> الخاصة بك ومنع خطر تصنيفها كبريد عشوائي.",
  "fallback_to_turbo_title": "إعادة تشكيل عنوان المرسل",
  "fallback_to_turbo_info": "اخترإعادة تشكيل عنوان المرسل لعنوان turboSMTP كمرسل للرسائل من نطاقات المرسل غير الموثوقة. قد يحسن ذلك قابلية التسليم، على الرغم من أن تغيير <strong>عنوان المرسل قد يُلاحظ</strong> من قبل المستلمين في عملاء البريد الإلكتروني الخاص بهم.",
  "notification_email_updated": "تم تحديث بريد الإخطار.",
  "notification_email_enabled": "تم تفعيل بريد الإخطار.",
  "notification_email_disabled": "تم تعطيل بريد الإخطار.",
  "invalid_notification_email": "بريد الإخطار غير صالح",
  "settings_sender_domains_new_intro": "أدخل معلومات النطاق الجديدة",
  "no_records_found": "لم يتم العثور على سجل DNS. تأكد من نشر السجل بشكل صحيح وأن الانتشار قد اكتمل.",
  "invalid_record_found": "تم العثور على سجل DNS ولكن يبدو أنه مُنسق بشكل غير صحيح أو يحتوي على قيمة غير صالحة.",
  "too_many_dns_lookups": "يحتوي سجل SPF على أكثر من الحد المسموح به من 10 عمليات بحث DNS وهو ما قد يتسبب في مشاكل بتوصيل الرسائل الإلكترونية.",
  "more_than_spf_entry_found": "تم اكتشاف عدة سجلات SPF لنطاقك. يُسمح بسجل SPF واحد فقط لكل نطاق.",
  "settings_sender_loading_domain_data": "جارِ تحميل نتائج التحقق من النطاق...",
  "notice": "تحذير",
  "settings_sender_domains_no_option": "<p>يعمل حسابك حاليًا تحت \"الوضع القياسي\"، وهو <strong>تكوين أقدم</strong> يقوم بإعادة تغليف جميع الرسائل الإلكترونية الصادرة بعنوان بريدنا الإلكتروني، بغض النظر عن إعدادات SPF، DKIM و DMARC الخاصة بك.</p>\n<p>لتحسين قابلية توصيل البريد الإلكتروني، نوصي بشدة باختيار واحد من خيارات السقوط الاحتياطية المحدثة المتاحة.</p>",
  "failed_to_get_a_aaaa_record": "فشل في الحصول على سجلات A / AAAA لـ {domain_name}",
  "invalid_spf_syntax": "صيغة SPF غير صالحة",
  "spf_has_upper_case_letters": "يجب ألا يحتوي سجل SPF على أحرف كبيرة. يُرجى التأكد من أن جميع الأحرف صغيرة للامتثال لمواصفات SPF.",
  "recursive_include_detected": "يجب ألا يتضمن سجل SPF النطاق نفسه لأن ذلك يخلق حلقة، مما يؤدي إلى عمليات بحث DNS لا نهائية. يُرجى تعديل إدخال SPF لإزالة الإشارة إلى النطاق لتجنب الاعتمادات الدائرية والامتثال لمواصفات SPF.",
  "spf_longer_than_255_characters": "يتجاوز سجل SPF حد الـ 255 حرفًا لسلسلة نصوص DNS واحدة. للامتثال لمواصفات DNS، يرجى تقسيم سجل SPF الخاص بك إلى سلاسل متعددة، كل منها لا يتجاوز 255 حرفًا، أو اختصار السجل للامتثال للحد المسموح به.",
  "ptr_mechanism_not_allowed": "لتحسين أداء SPF وتشجيع تبني ممارسات التحقق من الراسل القوية، يُنصح بإستبعاد آلية ptr والاعتماد بدلاً عنها على آليات مثل ip4 و include.",
  "data_location_modal_title": "موقع البيانات",
  "data_location_network_servers": "خوادم الشبكة",
  "data_location_ip_location": "موقع IP",
  "data_location_company_managing_data": "الشركة المديرة للبيانات",
  "data_location_network_servers_value": "ميلانو (IT)، فرانكفورت (DE)، أمستردام (NL)",
  "data_location_ip_location_value": "أوروبا RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl، إيطاليا EU",
  "data_location_no_transfer_outside_eu": "لا يتم نقل أي بيانات خارج الاتحاد الأوروبي",
  "gdpr_data_location": "البيانات في EU",
  "gdpr_see_details": "التفاصيل",
  "settings_apikeys_ips_label": "تقييد عنوان IP",
  "settings_apikeys_permissions_label": "أذونات واجهة برمجة التطبيقات",
  "settings_apikeys_permissions_description": "اختر الخدمات التي يمكن لمفتاح واجهة برمجة التطبيقات هذا الوصول إليها.",
  "settings_apikeys_permission_send_smtp": "إرسال SMTP",
  "settings_apikeys_permission_send_api": "إرسال HTTP API",
  "settings_apikeys_permission_apis": "إحصائيات وواجهات برمجة تطبيقات الإدارة",
  "settings_apikeys_permissions_required": "الرجاء تحديد خيار واحد على الأقل",
  "settings_apikeys_legacy_key_alert_message": "لقد قمنا بتحديث <strong>مصادقة SMTP</strong> الخاصة بنا لاستخدام <strong>مفاتيح API</strong> بدلاً من كلمة مرور حسابك. لضمان انتقال سلس، <strong>لقد أنشأنا مفتاح API خاص</strong> بك يتطابق مع بيانات الاعتماد القديمة الخاصة بك. لتحسين الأمان، نوصي بشدة <strong>بحذف هذا المفتاح وإنشاء مفتاح جديد</strong> لاستخدامه في إعدادات SMTP الخاصة بك.",
  "settings_apikeys_legacy_key_alert_link": "مزيد من المعلومات",
  "settings_apikeys_apikey_new_security_copy_cta": "نسخ إلى الحافظة",
  "settings_apikeys_apikey_new_security_copied_success": "تم النسخ!",
  "settings_apikeys_apikey_new_security_error": "فشل النسخ",
  "settings_apikeys_action_regenerate_secret": "إنشاء Consumer Secret جديد",
  "settings_apikeys_action_regenerate_secret_confirmation_message": "بإنشاء Consumer Secret جديد، ستتوقف جميع الأكواد التي تستخدم المفتاح الحالي عن العمل.",
  "settings_apikeys_action_regenerate_secret_confirmation": "أفهم، قم بإنشاء Consumer Secret جديد",
  "settings_apikeys_action_regenerate_secret_success": "تم إنشاء Consumer Secret جديد!",
  "not_included_in_plan": "غير مشمول في خطتك الحالية",
  "registration_logout": "تسجيل الخروج",
  "registration_step_personal": "المعلومات الشخصية",
  "registration_step_company": "معلومات الشركة",
  "registration_step_address": "معلومات العنوان",
  "registration_label_email": "البريد الإلكتروني",
  "registration_label_firstname": "الاسم الأول",
  "registration_label_lastname": "اسم العائلة",
  "registration_label_company": "الشركة",
  "registration_label_vat": "رقم ضريبة القيمة المضافة",
  "registration_label_vat_optional": "(اختياري)",
  "registration_label_phone": "رقم الهاتف",
  "registration_label_website": "الموقع الإلكتروني",
  "registration_label_website_hint": "(اختياري)",
  "registration_label_address": "العنوان",
  "registration_label_city": "المدينة",
  "registration_label_country": "البلد",
  "registration_placeholder_country": "اختر البلد",
  "registration_label_region": "الولاية / المنطقة",
  "registration_placeholder_region": "اختر المنطقة",
  "registration_label_zip": "الرمز البريدي",
  "registration_btn_back": "رجوع",
  "registration_btn_next": "الخطوة التالية",
  "registration_btn_complete": "إكمال الملف الشخصي",
  "registration_error_firstname": "الاسم الأول مطلوب.",
  "registration_error_lastname": "اسم العائلة مطلوب.",
  "registration_error_company": "اسم الشركة مطلوب.",
  "registration_error_phone": "رقم الهاتف مطلوب.",
  "registration_error_website": "الرجاء إدخال رابط صحيح.",
  "registration_error_address": "العنوان مطلوب.",
  "registration_error_city": "المدينة مطلوبة.",
  "registration_error_country": "البلد مطلوب.",
  "registration_error_region": "المنطقة مطلوبة.",
  "registration_error_zip": "الرمز البريدي مطلوب.",
  "registration_error_phone_format": "يجب أن يحتوي رقم الهاتف على أرقام فقط.",
  "registration_address_message": "من خلال التأكد من دقة عنوانك البريدي، يمكنك الاستفادة من <strong>تجربة تفعيل سريعة</strong>.",
  "registration_step_confirmation": "تأكيد",
  "registration_confirmation_title": "تم اكتمال الملف الشخصي!",
  "registration_confirmation_message": "تم إنشاء حسابك بنجاح.<br>يمكنك الآن شراء خطة لفتح الميزات المتقدمة وحدود إرسال أعلى",
  "registration_confirmation_message_buy": "تم إنشاء حسابك بنجاح.",
  "registration_btn_buy_plan": "شراء خطة",
  "registration_stay_free": "الاحتفاظ بالنسخة المجانية، يمكنك الترقية لاحقًا",
  "registration_btn_dashboard": "الذهاب إلى لوحة التحكم",
  "registration_redirect_to_shop": "سيتم إعادة توجيهك إلى عملية الدفع في لحظة...",
  "registration_go_to_shop": "انقر هنا للمتابعة إلى الدفع",
  "button_yes_delete": "نعم، احذف",
  "button_yes_revoke": "نعم، إبطال"
}
